import React, { ReactNode } from "react";

interface ContainerWrapperProps {
  additionalClasses?: string;
  children: ReactNode;
  containerColor?: string;
  containerOutlineColor?: string;
  hasContainer: boolean;
  hasDropShadow?: boolean;
  hasOutline?: boolean;
  hasRoundedBorder?: boolean;
}

const ContainerWrapper = ({
  additionalClasses = "",
  children,
  containerColor,
  containerOutlineColor,
  hasContainer,
  hasDropShadow,
  hasOutline,
  hasRoundedBorder = false,
}: ContainerWrapperProps): JSX.Element => {
  return (
    <div
      className={`
        ${additionalClasses}
        ${hasDropShadow ? "drop-shadow-lg" : ""}
        ${hasRoundedBorder ? "rounded" : ""}
      `}
      style={{
        backgroundColor: hasContainer ? containerColor : "transparent",
        border:
          hasContainer && hasOutline
            ? `1px solid ${containerOutlineColor}`
            : "none",
      }}
    >
      {children}
    </div>
  );
};

export default ContainerWrapper;
